import 'bootstrap/dist/js/bootstrap.bundle.min';
import { ptBR } from 'date-fns/locale';
import React from 'react';
import { registerLocale } from 'react-datepicker';
import ReactDOM from 'react-dom';
import '../node_modules/react-vis/dist/style.css';
import App from './App';
import './styles/app.scss';

registerLocale('pt-BR', ptBR);

ReactDOM.render(<App />, document.getElementById('root'));
